import { dataService } from '../../data';

import { DataObject, ObjectOptions, RelatedObject } from "../base";
import { CreateObject } from "../item";
import { Extra } from './extra';

/****************************/
/* SCHEMA DEFINITION        */
/****************************/

import { ExtraType } from '../types';
import { ProductType } from '../types';
import { ExtraOptionType } from '../types';

const _schema = {
    "name": "EXTRAPRODUCT",
    "fields": [
        { name: "status", type: "string", default: "AC" },
        { name: "extra", type: "objid" },
        { name: "product", type: "objid" }
    ],
    relate: [
        { direction: ">", target: "EXTRA", by: "extra", name: "extra", reason: "extra", child: false, class: ExtraType },
        { direction: ">", target: "PRODUCT", by: "product", name: "product", reason: "product", child: false, class: ProductType },
        { direction: "<", target: "EXTRAPRODUCTOPT", by: "product", name: "option", reason: "options", child: true, class: ExtraOptionType }
    ]
} as const;

const _ExtraProductClass = CreateObject(_schema);
if (!_ExtraProductClass) {
    throw new Error("Failed to create BaseClass for '" + _schema.name + "'");
}

/****************************/
/* CLASS DECLARATION        */
/****************************/

export class ExtraProduct extends _ExtraProductClass { 
    constructor(objid: string | null, data: dataService, objoptions: ObjectOptions | null = null){
        super(_schema, objid, data, objoptions || {});
    }

    Copy(store: Array<DataObject> = []): ExtraProduct {
        return this._Copy(store) as ExtraProduct;
    }

    protected override DoChildLinked(relation: string | null, related: RelatedObject | null): void {
        if (this.CopyOf || !this.Commited){
            return;
        }

        if (relation === 'extra' && related instanceof Extra){
            if (related === this.extra){
                related.AddProduct(this);
            }
        }
    }

    /****************************/
    /* CLASS MEMBERS            */
    /****************************/

    get status(): string | null {
        return this['__base__status']
    }

    set status(value: string){
        if (this.status == 'DE'){
            return;     // cannot modify deleted items
        }

        if (this.status == value){
            return;
        }

        this['__base__status'] = value;
        if (this.extra){
            if ((this.status == 'DE') && !this.Commited){
                this.extra.DelProduct(this);
            }
            else {
                this.extra.DoRefresh(this.table);
            }    
        }
    }

    /****************************/
    /* CUSTOM METHODS           */
    /****************************/

    get IsValid(): boolean {
        return (!!this.status && (this.status != 'DE'));
    }
}

